export const reel3 = {
    id: 'reel-3',
    schemaVersion: 2,
    covers: 'A hook and four flowing statements building to an end card. Suits a persuasive case made in a few sentences rather than a numbered list.',
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 869,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 4],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                motion: {
                    tracks: [
                        {
                            channel: 'brightness',
                            from: 0.53,
                            to: 1.24,
                            duration: 11,
                            easing: 'ease-out',
                            anchor: {
                                at: 'start',
                                frame: 0,
                            },
                        },
                        {
                            channel: 'brightness',
                            from: 1.24,
                            to: 1,
                            duration: 10,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 11,
                            },
                        },
                        {
                            channel: 'blur',
                            from: 12,
                            to: 0,
                            duration: 18,
                            easing: 'ease-out',
                            anchor: {
                                at: 'start',
                                frame: 0,
                            },
                        },
                        {
                            channel: 'x',
                            from: -24,
                            to: 0,
                            duration: 21,
                            easing: 'ease-out',
                            anchor: {
                                at: 'start',
                                frame: 0,
                            },
                        },
                        {
                            channel: 'scale',
                            from: 1.11,
                            to: 1,
                            duration: 21,
                            easing: 'ease-out',
                            anchor: {
                                at: 'start',
                                frame: 0,
                            },
                        },
                    ],
                },
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 2.9,
                            transition: {
                                mask: 'thirds-cascade',
                            },
                        },
                        {
                            atSec: 14.2,
                            transition: 'cut',
                        },
                        {
                            atSec: 17.467,
                            transition: 'fade',
                        },
                        {
                            atSec: 23.933,
                            transition: 'fade',
                        },
                    ],
                },
            },
        ],
        overlays: [
            {
                kind: 'light-rays',
                id: 'light-sweep',
                duration: {
                    kind: 'fixed',
                    frames: 60,
                },
                start: {
                    at: 'frame',
                    value: 0,
                },
                count: 200,
                angle: 0,
                thickness: 0.88,
                softness: 1,
                feather: 0.45,
                color: {
                    source: 'fixed',
                    value: '#FFF6E8',
                },
                intensity: 0.38,
                blend: 'screen',
                entrance: {
                    animation: 'fade-in',
                },
                placement: {
                    anchor: 'center',
                    x: 0.39,
                    y: 0.5,
                    width: 0.34,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'x',
                            from: -421,
                            to: 0,
                            duration: 20,
                            easing: 'ease-out',
                            anchor: {
                                at: 'start',
                                frame: 0,
                            },
                        },
                        {
                            channel: 'opacity',
                            from: 0.72,
                            to: 1,
                            duration: 20,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 0,
                            },
                        },
                    ],
                },
            },
            {
                kind: 'media-overlay',
                id: 'stack-top',
                clip: {
                    source: 'query',
                    query: {
                        kind: 'asset-media',
                        tag: 'procedure',
                        mediaType: 'video',
                    },
                    required: false,
                },
                placement: {
                    kind: 'rect',
                    x: 0,
                    y: 0,
                    w: 1,
                    h: 0.5,
                },
                fit: 'cover',
                duration: {
                    kind: 'fixed',
                    frames: 96,
                },
                start: {
                    at: 'frame',
                    value: 428,
                },
            },
            {
                kind: 'media-overlay',
                id: 'stack-bottom',
                clip: {
                    source: 'query',
                    query: {
                        kind: 'asset-media',
                        tag: 'procedure',
                        mediaType: 'video',
                    },
                    required: false,
                },
                placement: {
                    kind: 'rect',
                    x: 0,
                    y: 0.5,
                    w: 1,
                    h: 0.5,
                },
                fit: 'cover',
                duration: {
                    kind: 'fixed',
                    frames: 96,
                },
                start: {
                    at: 'frame',
                    value: 428,
                },
            },
            {
                kind: 'group',
                id: 'scene-0',
                duration: {
                    kind: 'fixed',
                    frames: 105,
                },
                start: {
                    at: 'frame',
                    value: 13,
                },
                placement: {
                    anchor: 'center',
                    x: 0.506,
                    y: 0.2814,
                    width: 0.72,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 105,
                                fontWeight: 500,
                                whiteSpace: 'pre-line',
                                lineHeight: 0.99,
                            },
                            align: 'center',
                            motion: {
                                token: 'letter-fade-scattered',
                                durationFrames: 46,
                                tracks: [
                                    {
                                        channel: 'reveal',
                                        from: 1,
                                        to: 0,
                                        anchor: {
                                            at: 'end',
                                            frame: 10,
                                        },
                                        duration: 10,
                                        easing: 'linear',
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-1',
                duration: {
                    kind: 'fixed',
                    frames: 130,
                },
                start: {
                    at: 'frame',
                    value: 142,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.501,
                    y: 0.837,
                    width: 0.717,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 64.3,
                                fontWeight: 500,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 13,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 66.6,
                                fontWeight: 500,
                                whiteSpace: 'nowrap',
                                fontStyle: 'italic',
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 24,
                            align: 'center',
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'group',
                id: 'scene-2',
                duration: {
                    kind: 'fixed',
                    frames: 138,
                },
                start: {
                    at: 'frame',
                    value: 287,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.497,
                    y: 0.841,
                    width: 0.874,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement3',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 63.4,
                                fontWeight: 500,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'fade-in',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement4',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 63.4,
                                fontWeight: 500,
                                whiteSpace: 'nowrap',
                                fontStyle: 'italic',
                            },
                            entrance: 'fade-in',
                            align: 'center',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'scene-3',
                duration: {
                    kind: 'fixed',
                    frames: 120,
                },
                start: {
                    at: 'frame',
                    value: 442,
                },
                placement: {
                    anchor: 'center',
                    x: 0.506,
                    y: 0.495,
                    width: 0.825,
                },
                root: {
                    kind: 'text',
                    content: {
                        source: 'slot',
                        slot: {
                            source: 'query',
                            query: {
                                kind: 'content',
                                field: 'statement5',
                            },
                            required: true,
                        },
                    },
                    style: 'display',
                    styleOverride: {
                        colorRole: 'onPrimary',
                        textTransform: 'none',
                        fontSize: 52,
                        fontWeight: 500,
                    },
                    entrance: 'word-by-word',
                    entranceDurationFrames: 28,
                    align: 'center',
                },
            },
            {
                kind: 'group',
                id: 'scene-4',
                duration: {
                    kind: 'fixed',
                    frames: 142,
                },
                start: {
                    at: 'frame',
                    value: 575,
                },
                placement: {
                    anchor: 'bottom',
                    x: 0.508,
                    y: 0.747,
                    width: 0.744,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 6,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement6',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 62.8,
                                fontWeight: 500,
                                whiteSpace: 'nowrap',
                            },
                            entrance: 'word-by-word',
                            entranceDurationFrames: 29,
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'statement7',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 59.7,
                                fontWeight: 500,
                                whiteSpace: 'nowrap',
                                fontStyle: 'italic',
                            },
                            entrance: 'fade-in',
                            entranceDurationFrames: 27,
                            align: 'center',
                        },
                    ],
                },
                ridesWith: {
                    track: 'broll',
                },
            },
            {
                kind: 'rect',
                id: 'dip-to-black',
                duration: {
                    kind: 'fixed',
                    frames: 16,
                },
                start: {
                    at: 'frame',
                    value: 419,
                },
                color: {
                    source: 'fixed',
                    value: '#000000',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                    height: 1,
                },
                entrance: {
                    animation: 'none',
                },
                motion: {
                    tracks: [
                        {
                            channel: 'opacity',
                            from: 0,
                            to: 0.77,
                            anchor: {
                                at: 'start',
                                frame: 0,
                            },
                            duration: 7,
                            easing: 'linear',
                        },
                        {
                            channel: 'opacity',
                            from: 0.77,
                            to: 0,
                            anchor: {
                                at: 'start',
                                frame: 7,
                            },
                            duration: 8,
                            easing: 'linear',
                        },
                    ],
                },
            },
            {
                kind: 'group',
                id: 'card-0',
                start: {
                    at: 'frame',
                    value: 718,
                },
                duration: {
                    kind: 'fixed',
                    frames: 151,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: '#120D07',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                        adoptLogoScrim: true,
                    },
                },
            },
            {
                kind: 'group',
                id: 'brand-card-0',
                start: {
                    at: 'frame',
                    value: 729,
                },
                duration: {
                    kind: 'fixed',
                    frames: 140,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5079,
                    y: 0.3692,
                    width: 0.62,
                },
                root: {
                    kind: 'logo',
                    url: {
                        source: 'query',
                        query: {
                            kind: 'brand',
                            field: 'logoUrl',
                        },
                        required: false,
                    },
                    width: 1,
                    entrance: 'fade-in',
                    entranceDurationFrames: 20,
                },
            },
            {
                kind: 'rect',
                id: 'bar-offer',
                start: {
                    at: 'frame',
                    value: 728,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5007,
                    y: 0.5805,
                    width: 0.7986,
                    height: 0.0625,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-offer',
                start: {
                    at: 'frame',
                    value: 728,
                },
                duration: {
                    kind: 'fixed',
                    frames: 141,
                },
                placement: {
                    anchor: 'center',
                    x: 0.498,
                    y: 0.5761,
                    width: 0.78,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'offer1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 51.3,
                                fontWeight: 300,
                                fontStyle: 'italic',
                                lineHeight: 1.05,
                                whiteSpace: 'nowrap',
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'offer2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 51.3,
                                fontWeight: 300,
                                fontStyle: 'italic',
                                lineHeight: 1.05,
                                whiteSpace: 'nowrap',
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'rect',
                id: 'bar-cta',
                start: {
                    at: 'frame',
                    value: 736,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.4993,
                    y: 0.6375,
                    width: 0.7986,
                    height: 0.0234,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-cta',
                start: {
                    at: 'frame',
                    value: 736,
                },
                duration: {
                    kind: 'fixed',
                    frames: 133,
                },
                placement: {
                    anchor: 'center',
                    x: 0.4986,
                    y: 0.6374,
                    width: 0.9,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'cta',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 34.4,
                                fontWeight: 100,
                                lineHeight: 1.1,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.11,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
            {
                kind: 'rect',
                id: 'bar-tagline',
                start: {
                    at: 'frame',
                    value: 741,
                },
                duration: {
                    kind: 'fixed',
                    frames: 9,
                },
                color: {
                    source: 'fixed',
                    value: '#F2F1EC',
                },
                entrance: {
                    animation: 'none',
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.7656,
                    width: 0.9138,
                    height: 0.0516,
                },
                motion: {
                    tracks: [
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                                to: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                            },
                        },
                        {
                            channel: 'mask',
                            from: 0,
                            to: 1,
                            duration: 4,
                            easing: 'ease-in',
                            anchor: {
                                at: 'start',
                                frame: 4,
                            },
                            mask: {
                                shape: 'rect',
                                from: {
                                    x: 0,
                                    y: 0,
                                    w: 1,
                                    h: 1,
                                },
                                to: {
                                    x: 1,
                                    y: 0,
                                    w: 0,
                                    h: 1,
                                },
                            },
                        },
                    ],
                },
                colorRole: 'onLogoScrim',
            },
            {
                kind: 'group',
                id: 'endcard-tagline',
                start: {
                    at: 'frame',
                    value: 741,
                },
                duration: {
                    kind: 'fixed',
                    frames: 128,
                },
                placement: {
                    anchor: 'center',
                    x: 0.4996,
                    y: 0.7652,
                    width: 0.86,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'tagline1',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 44.1,
                                fontWeight: 100,
                                lineHeight: 1.06,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.048,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'tagline2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                fontRef: 'inter',
                                textTransform: 'none',
                                fontSize: 44.1,
                                fontWeight: 100,
                                lineHeight: 1.06,
                                whiteSpace: 'nowrap',
                                letterSpacing: 0.048,
                                colorRole: 'onLogoScrim',
                            },
                            entrance: 'none',
                            align: 'center',
                        },
                    ],
                    motion: {
                        tracks: [
                            {
                                channel: 'clip',
                                from: 0,
                                to: 1,
                                duration: 4,
                                easing: 'ease-in',
                                anchor: {
                                    at: 'start',
                                    frame: 4,
                                },
                            },
                        ],
                    },
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        hook: {
            type: 'text',
            maxChars: 44,
            description: 'Opens the invitation — the promise the next twenty seconds elaborate, in an elevated register about the EXPERIENCE rather than the treatment\'s mechanism. Newlines are honoured as line breaks (three lines in the source) and *asterisks* italicise a phrase. Source shape: "Step into a new / standard of / beauty."',
        },
        statement: {
            type: 'text',
            maxChars: 30,
            description: 'Beat one, line 1 — invites the viewer into the service by name. First half of a two-line beat; the pair is one sentence. Source shape: "Indulge in luxurious / nail services..."',
        },
        statement2: {
            type: 'text',
            maxChars: 31,
            description: 'Completes beat one. If it ends on an ellipsis, `statement3` picks the sentence up — the source runs one clause across the beat boundary deliberately.',
        },
        statement3: {
            type: 'text',
            maxChars: 30,
            description: 'Beat two, line 1 — continues from beat one rather than starting a new claim, and says what makes the service considered rather than routine. Source shape: "...thoughtfully designed to"',
        },
        statement4: {
            type: 'text',
            maxChars: 30,
            description: 'Completes beat two, landing on the client. Source shape: "cater to your unique style."',
        },
        statement5: {
            type: 'text',
            maxChars: 43,
            description: 'Beat three, standing alone on one line — the shortest, most quotable claim in the video, about standard of care. Source shape: "Unrivalled care and precision."',
        },
        statement6: {
            type: 'text',
            maxChars: 30,
            description: 'Beat four, line 1 — closes by naming what the clinic IS to the client, not what it does. Source shape: "A destination for your"',
        },
        statement7: {
            type: 'text',
            maxChars: 27,
            description: 'Completes beat four and hands off to the end card. Source shape: "transformation."',
        },
        offer1: {
            type: 'text',
            maxChars: 34,
            description: "The first of two lines naming something CONCRETE the viewer can take up — a consultation, a patch test, a named treatment, a specific package. Name the thing itself; 'our range of services' is not an offer. Set in italic sans, apart from the rest of the card.",
        },
        offer2: {
            type: 'text',
            maxChars: 34,
            description: 'The second offer line, completing the first rather than starting a new one — the condition, the timing, or what is included. The two lines are read together as one offer.',
        },
        cta: {
            type: 'text',
            maxChars: 46,
            description: "The end-card call to action: the single action to take, as a verb phrase — 'Book a consultation', 'Message us to check your suitability'. An instruction, not a slogan. May carry **bold** runs on the words that matter.",
        },
        tagline1: {
            type: 'text',
            maxChars: 30,
            description: "The first of two closing tagline lines — the clinic's standing promise, not anything specific to this treatment. May carry *italic* runs.",
        },
        tagline2: {
            type: 'text',
            maxChars: 30,
            description: 'The second tagline line, completing the first. The two are read as one phrase, so it must not restate line one.',
        },
    },
    structure: "One flowing invitation, built across four beats — not four separate claims. Each beat continues the register of the one before it, and the source even runs an ellipsis across a beat boundary ('Indulge in luxurious nail services...' / '...thoughtfully designed to cater to your unique style.'). Elevated, unhurried, about the EXPERIENCE rather than the mechanism. The source ends: \"A destination for your transformation.\"",
};
//# sourceMappingURL=reel-3.js.map